export const DISPLAY_IN_TYPE = {
  ANNUAL: 'annual',
  HOURLY: 'hourly',
  THOUSANDS: 'thousands'
};

export const getDisplayInFromPayDivisor = payDivisor => {
  if (payDivisor === 1000) {
    return DISPLAY_IN_TYPE.THOUSANDS;
  } else if (payDivisor === 2080) {
    return DISPLAY_IN_TYPE.HOURLY;
  }
  return DISPLAY_IN_TYPE.ANNUAL;
};

export const getMonetaryRoundingFromDisplayInType = displayInType => {
  if (displayInType === DISPLAY_IN_TYPE.THOUSANDS) {
    return 1;
  } else if (displayInType === DISPLAY_IN_TYPE.HOURLY) {
    return 2;
  }
  return 0;
};
